/**
 * gatsby-browser.js
 * Runs in the browser after Gatsby hydration.
 * - Imports the single global stylesheet
 * - Boots scroll-triggered animations on every route change
 */

import "./src/styles/global.css";

/**
 * Called after every route change (including the initial load).
 * Re-observes all `.animate` elements so animations replay
 * correctly when navigating between pages.
 */
export const onRouteUpdate = () => {
  if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
    return;
  }

  const targets = document.querySelectorAll(".animate");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  targets.forEach((el) => {
    el.classList.remove("visible");
    observer.observe(el);
  });
};
